// no-dd-sa:javascript-code-style/max-params,javascript-code-style/parameter-name
export const getFormMetadata = (isUpdate, regionsOptions, COURIER_TYPES, handleSelectTypeChange, handleSelectRegionChange, optPlatforms, handlePlatformChange, typeValue) => {
  return [
    {
      id: 'company',
      label: 'Company',
      column: 8,
    },
    {
      id: 'code',
      label: 'Alias',
      subLabel: '(optional)',
      column: 4,
    },
    {
      id: 'type',
      label: 'Type',
      type: 'autoselect',
      options: COURIER_TYPES,
      placeholder: 'Select Type',
      style: { marginTop: '9px' },
      handleChange: handleSelectTypeChange,
      column: typeValue === 'PLATFORM' ? 6 : 12,
    },
    typeValue === 'PLATFORM' && {
      id: 'platform',
      label: 'Platform',
      type: 'autoselect',
      options: optPlatforms,
      placeholder: 'Select Platform',
      style: { marginTop: '9px' },
      handleChange: handlePlatformChange,
      column: 6,
    },
    {
      id: 'regions',
      label: 'Regions',
      column: 12,
      type: 'autocomplete',
      options: regionsOptions,
      placeholder: 'Select Region',
      style: { marginTop: '9px' },
      handleChange: handleSelectRegionChange,
    },
    {
      id: 'email',
      label: 'Email',
    },
    {
      id: 'phone_number',
      label: 'Phone Number',
      maxLength: 12,
    },
    {
      id: 'username',
      label: 'Username',
      column: isUpdate ? 12 : 6,
      disabled: isUpdate,
    },
    !isUpdate && {
      id: 'password',
      label: 'Password',
      column: 6,
    },
  ];
};

export const VALIDATE_RULES = {
  username: {
    presence: {
      allowEmpty: false,
      message: 'is required',
    },
  },
  password: {
    presence: {
      allowEmpty: false,
      message: 'is required',
    },
  },
  company: {
    presence: {
      allowEmpty: false,
      message: 'is required',
    },
  },
  email: {
    email: {
      message: 'is not a valid email',
    },
  },
  phone_number: {
    format: {
      pattern: /^\+1\d{10}$/,
      message: 'is wrong phone number format, only allow country code (+1) and 10 digits',
    },
  },
  regions: {
    presence: {
      allowEmpty: false,
      message: 'is required',
    },
  },
  type: {
    presence: {
      allowEmpty: false,
      message: 'is required',
    },
  },
  platform: {
    presence: {
      allowEmpty: false,
      message: 'is required',
    },
  },
};

export const COURIER_TYPES = [
  {
    label: 'PLATFORM',
    value: 'PLATFORM',
  },
  {
    label: 'DSP',
    value: 'DSP',
  },
  {
    label: 'LINEHAUL',
    value: 'LINEHAUL',
  },
];
